var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`el-${_vm.item.type}`,_vm._g(_vm._b({tag:"component",attrs:{"item":_vm.item,"optionList":_vm.optionList}},'component',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }